"use client";
import { ICPServiceType1 } from "@/types/global";
import ServiceAreaCard from "./service-area-card";

const ServiceArea = ({ title, description, data }: { title: string, description: string, data: ICPServiceType1[] }) => {
    return (
        <section className="desilo-service5-section section-padding-top overflow-hidden">
            <div className="container custom-container">
                <div className="row">
                    <div className="col-12 col-lg-9 col-xl-7 col-xxl-6">
                        <div className="desilo__header">
                            <h2 className="title">
                                {title}
                            </h2>
                            <p className="hero2-content-text">
                                {description}
                            </p>
                            <h3 className="pt-4">Modern Creator-Economy Platform Solutions</h3>
                        </div>
                    </div>
                </div>
                <div className="row gx-4 gy-5 row-padding-top">
                    {/* service card start */}
                    {data.map((item, i) => (
                        <div key={i} className="col-md-6 col-lg-4 col-xxl-3">
                            <ServiceAreaCard data={item} />
                        </div>
                    ))}
                    {/* service card end */}
                </div>
            </div>
        </section>
    );
};

export default ServiceArea;
